import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { NodeService } from 'src/app/services/node-service/node-service.service';

@Component({
  selector: 'app-mass-delete',
  templateUrl: './mass-delete.component.html',
  styleUrls: ['./mass-delete.component.css'],
  standalone: false,
})
export class MassDeleteComponent implements OnInit {
  subscriptionCategoriesList: Subscription = new Subscription();
  data: [] = [];
  poisToDelete: number[] = [];
  @Output() idSelected = new EventEmitter<number[]>();

  constructor(
    private nodeService: NodeService,
    private dialogRef: MatDialogRef<MassDeleteComponent>
  ) {}

  ngOnInit(): void {
    this.poisToDelete = this.nodeService.getPoisToMove();
  }

  noDelete() {
    this.dialogRef.close(false);
  }

  handleSelected() {
    this.idSelected.emit(this.poisToDelete);
    this.dialogRef.close(true);
  }
}
